import { useEffect, useState } from 'react';
import * as telegram from './telegram';
import { KeyboardState } from './keyboard-state';

function editingText(): boolean {
  const element = document.activeElement;
  return element instanceof HTMLElement && (
    element.isContentEditable ||
    (element instanceof HTMLTextAreaElement && !element.readOnly && !element.disabled) ||
    (element instanceof HTMLInputElement && !element.readOnly && !element.disabled &&
      ['text', 'search', 'email', 'url', 'tel', 'number', 'password'].includes(element.type))
  );
}

export function useKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const viewport = window.visualViewport;
    const height = () => Math.min(window.innerHeight, viewport?.height ?? window.innerHeight, telegram.viewportHeight() ?? window.innerHeight);
    const tracker = new KeyboardState(height(), window.innerWidth);
    const touch = window.matchMedia('(pointer: coarse)').matches;
    let blurTimer: ReturnType<typeof setTimeout> | undefined;
    const update = () => setOpen(tracker.update(height(), window.innerWidth, editingText(), touch));
    const focus = () => {
      clearTimeout(blurTimer);
      setOpen(tracker.update(height(), window.innerWidth, editingText(), touch, true));
    };
    // Keep the panel hidden when moving between fields and during keyboard dismissal.
    const blur = () => { blurTimer = setTimeout(update, 150); };
    const unsubscribeTelegram = telegram.onViewportChange(update);
    window.addEventListener('resize', update);
    viewport?.addEventListener('resize', update);
    document.addEventListener('focusin', focus);
    document.addEventListener('focusout', blur);
    update();
    return () => {
      clearTimeout(blurTimer);
      unsubscribeTelegram();
      window.removeEventListener('resize', update);
      viewport?.removeEventListener('resize', update);
      document.removeEventListener('focusin', focus);
      document.removeEventListener('focusout', blur);
    };
  }, []);
  return open;
}
